angular.module("khUtils").factory("KhutilsFarmFieldFactory", ["$resource", function ($resource) {
    return $resource('api/v1.0/khutils/fields/:farm_field_slug/');
}]);